




















































import { Vue, Prop, Component } from "vue-property-decorator";
import { Application as IApplication } from "@/api/models/application";

@Component({ components: {} })
export default class ApiTableItem extends Vue {
  @Prop() app!: IApplication;
  data() {
    return {};
  }

  get screenWidth() {
    return window.innerWidth;
  }

  deleteApi() {
    this.$emit("remItem", this.app.id);
  }
}
